module.exports = __webpack_public_path__ + "img/symbol_10.d7d30fe4.png";